var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "group-content" },
    [
      _c("single-select-accessible", {
        attrs: {
          title:
            "BudgetaryEstimate.Investment.SupportApartments.Apartment.TargetGroup",
          options: _vm.targetGroupOptions,
          doNotUseResources: true,
          required: true,
          fixedDirection: true,
          dropdownId: "targetGroup_" + _vm.index
        },
        model: {
          value: _vm.apartment.targetGroup,
          callback: function($$v) {
            _vm.$set(_vm.apartment, "targetGroup", $$v)
          },
          expression: "apartment.targetGroup"
        }
      }),
      _vm._v(" "),
      _vm.apartment.targetGroup == _vm.otherTargetGroupId
        ? _c("text-area-row", {
            attrs: {
              title:
                "InvestmentReport.Finances.ApartmentAcquisitions.OtherTargetGroup",
              rows: 1,
              maxLength: 100,
              required: true,
              hideCharsLeft: true,
              placeholder:
                "InvestmentReport.Finances.ApartmentAcquisitions.OtherTargetGroupPlaceholder"
            },
            model: {
              value: _vm.apartment.otherTargetGroup,
              callback: function($$v) {
                _vm.$set(_vm.apartment, "otherTargetGroup", $$v)
              },
              expression: "apartment.otherTargetGroup"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("radio-button-row", {
        attrs: {
          title:
            "InvestmentReport.Finances.ApartmentAcquisitions.PriceRuleIsCleared",
          componentIndex: _vm.index,
          required: true
        },
        model: {
          value: _vm.apartment.acquisitionPriceRuleIsCleared,
          callback: function($$v) {
            _vm.$set(_vm.apartment, "acquisitionPriceRuleIsCleared", $$v)
          },
          expression: "apartment.acquisitionPriceRuleIsCleared"
        }
      }),
      _vm._v(" "),
      _c("numeric-input-row", {
        attrs: {
          title:
            "InvestmentReport.Finances.ApartmentAcquisitions.FreeOfDebtPrice",
          id: "price_" + _vm.index,
          required: true,
          minValue: 1
        },
        model: {
          value: _vm.apartment.freeOfDebtPrice,
          callback: function($$v) {
            _vm.$set(_vm.apartment, "freeOfDebtPrice", $$v)
          },
          expression: "apartment.freeOfDebtPrice"
        }
      }),
      _vm._v(" "),
      _c("numeric-input-row", {
        attrs: {
          title: "InvestmentReport.Finances.ApartmentAcquisitions.TransferTax",
          id: "tax_" + _vm.index,
          required: true
        },
        model: {
          value: _vm.apartment.transferTax,
          callback: function($$v) {
            _vm.$set(_vm.apartment, "transferTax", $$v)
          },
          expression: "apartment.transferTax"
        }
      }),
      _vm._v(" "),
      _c("numeric-input-row", {
        attrs: {
          title: "InvestmentReport.Finances.ApartmentAcquisitions.RepairCosts",
          id: "repairs_" + _vm.index
        },
        model: {
          value: _vm.apartment.repairCosts,
          callback: function($$v) {
            _vm.$set(_vm.apartment, "repairCosts", $$v)
          },
          expression: "apartment.repairCosts"
        }
      }),
      _vm._v(" "),
      _c("numeric-input-row", {
        attrs: {
          title: "InvestmentReport.Finances.ApartmentAcquisitions.TotalCosts",
          id: "totalCosts_" + _vm.index,
          disabled: true
        },
        model: {
          value: _vm.totalCosts,
          callback: function($$v) {
            _vm.totalCosts = $$v
          },
          expression: "totalCosts"
        }
      }),
      _vm._v(" "),
      _c("numeric-input-row", {
        attrs: {
          title:
            "InvestmentReport.Finances.ApartmentAcquisitions.YearOfAcquisition",
          id: "year_" + _vm.index,
          required: true,
          minValue: 1000,
          maxValue: _vm.currentYear
        },
        model: {
          value: _vm.apartment.yearOfAcquisition,
          callback: function($$v) {
            _vm.$set(_vm.apartment, "yearOfAcquisition", $$v)
          },
          expression: "apartment.yearOfAcquisition"
        }
      }),
      _vm._v(" "),
      _c("single-select-accessible", {
        attrs: {
          title: "InvestmentReport.Finances.ApartmentAcquisitions.PledgeType",
          options: _vm.pledgeTypeOptions,
          doNotUseResources: true,
          required: true,
          fixedDirection: true,
          dropdownId: "pledgeType_" + _vm.index
        },
        model: {
          value: _vm.apartment.typeOfPledge,
          callback: function($$v) {
            _vm.$set(_vm.apartment, "typeOfPledge", $$v)
          },
          expression: "apartment.typeOfPledge"
        }
      }),
      _vm._v(" "),
      _c("single-select-accessible", {
        attrs: {
          title: "InvestmentReport.Finances.ApartmentAcquisitions.RentType",
          options: _vm.rentTypeOptions,
          doNotUseResources: true,
          required: true,
          fixedDirection: true,
          dropdownId: "rentType_" + _vm.index
        },
        model: {
          value: _vm.apartment.typeOfRent,
          callback: function($$v) {
            _vm.$set(_vm.apartment, "typeOfRent", $$v)
          },
          expression: "apartment.typeOfRent"
        }
      }),
      _vm._v(" "),
      _c("decimal-input-row", {
        attrs: {
          title:
            "InvestmentReport.Finances.ApartmentAcquisitions.RentPerSquareMeter",
          id: "rent_" + _vm.index,
          required: true,
          minValue: 1,
          decimals: 2
        },
        model: {
          value: _vm.apartment.rentPerSquareMeter,
          callback: function($$v) {
            _vm.$set(_vm.apartment, "rentPerSquareMeter", $$v)
          },
          expression: "apartment.rentPerSquareMeter"
        }
      }),
      _vm._v(" "),
      _c("numeric-input-row", {
        attrs: {
          title: "InvestmentReport.Finances.ApartmentAcquisitions.Size",
          id: "size_" + _vm.index,
          required: true,
          minValue: 1
        },
        model: {
          value: _vm.apartment.size,
          callback: function($$v) {
            _vm.$set(_vm.apartment, "size", $$v)
          },
          expression: "apartment.size"
        }
      }),
      _vm._v(" "),
      _c("single-select-accessible", {
        attrs: {
          title:
            "InvestmentReport.Finances.ApartmentAcquisitions.ApartmentRooms",
          options: _vm.roomsOptions,
          doNotUseResources: true,
          required: true,
          fixedDirection: true,
          dropdownId: "rooms_" + _vm.index
        },
        model: {
          value: _vm.apartment.numberOfRooms,
          callback: function($$v) {
            _vm.$set(_vm.apartment, "numberOfRooms", $$v)
          },
          expression: "apartment.numberOfRooms"
        }
      }),
      _vm._v(" "),
      _c("numeric-input-row", {
        attrs: {
          title:
            "InvestmentReport.Finances.ApartmentAcquisitions.ConstructionYear",
          id: "constructionYear_" + _vm.index,
          required: true,
          minValue: 1000,
          maxValue: _vm.currentYear
        },
        model: {
          value: _vm.apartment.constructionYear,
          callback: function($$v) {
            _vm.$set(_vm.apartment, "constructionYear", $$v)
          },
          expression: "apartment.constructionYear"
        }
      }),
      _vm._v(" "),
      _c("single-select-accessible", {
        attrs: {
          title:
            "InvestmentReport.Finances.ApartmentAcquisitions.TypeOfHousing",
          options: _vm.housingOptions,
          doNotUseResources: true,
          required: true,
          fixedDirection: true,
          dropdownId: "housing_" + _vm.index
        },
        model: {
          value: _vm.apartment.typeOfHousing,
          callback: function($$v) {
            _vm.$set(_vm.apartment, "typeOfHousing", $$v)
          },
          expression: "apartment.typeOfHousing"
        }
      }),
      _vm._v(" "),
      _c("text-area-row", {
        attrs: {
          title: "InvestmentReport.Finances.ApartmentAcquisitions.BusinessId",
          rows: 1,
          maxLength: 10,
          required: !(_vm.apartment.shareGroupId || _vm.apartment.realEstateId),
          hideCharsLeft: true,
          rules: _vm.businessIdRules
        },
        model: {
          value: _vm.apartment.businessId,
          callback: function($$v) {
            _vm.$set(_vm.apartment, "businessId", $$v)
          },
          expression: "apartment.businessId"
        }
      }),
      _vm._v(" "),
      _c("text-area-row", {
        attrs: {
          title: "InvestmentReport.Finances.ApartmentAcquisitions.ShareGroupId",
          rows: 1,
          maxLength: 16,
          required: !(_vm.apartment.businessId || _vm.apartment.realEstateId),
          hideCharsLeft: true,
          rules: _vm.shareGroupIdRules
        },
        model: {
          value: _vm.apartment.shareGroupId,
          callback: function($$v) {
            _vm.$set(_vm.apartment, "shareGroupId", $$v)
          },
          expression: "apartment.shareGroupId"
        }
      }),
      _vm._v(" "),
      _c("text-area-row", {
        attrs: {
          title: "InvestmentReport.Finances.ApartmentAcquisitions.RealEstateId",
          rows: 1,
          maxLength: 20,
          required: !(_vm.apartment.businessId || _vm.apartment.shareGroupId),
          rules: _vm.realEstateIdRules,
          hideCharsLeft: true
        },
        model: {
          value: _vm.apartment.realEstateId,
          callback: function($$v) {
            _vm.$set(_vm.apartment, "realEstateId", $$v)
          },
          expression: "apartment.realEstateId"
        }
      }),
      _vm._v(" "),
      _c("address-control", {
        attrs: {
          item: _vm.apartment.address,
          isInvestmentReport: true,
          hideHeader: true
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }